// extracted by mini-css-extract-plugin
export default {"wrapper":"StatelessCard_wrapper__6FhSw","flex-1":"StatelessCard_flex-1__XWGhj","flex-2":"StatelessCard_flex-2__d6NdO","with-padding":"StatelessCard_with-padding__rpEK6"};